import React, { Component } from 'react';
import { connect } from "react-redux";
import { apiCall } from "../helpers/MainHelper";

const SubscriptionPermissionsControl = (WrappedComponent) => {
    class SubscriptionPermissionsControl extends Component {
        state = {
            subscriptionCode: "none",
            hasSubscriptionAccess: null,
        };

        componentDidMount() {
            if (this.props.isLoggedin) {
                this.loadEntitlement();
            }
        }

        componentDidUpdate(prevProps) {
            if (!prevProps.isLoggedin && this.props.isLoggedin) {
                this.loadEntitlement();
            }
        }

        getCachedCode = () => {
            const cachedUser = JSON.parse(localStorage.getItem('user'));
            if (cachedUser && cachedUser.service && cachedUser.service.subscription_type_code) {
                return cachedUser.service.subscription_type_code;
            }
            return "none";
        }

        loadEntitlement = async () => {
            const fallbackCode = this.getCachedCode();
            try {
                const response = await apiCall('business/subscription/entitlement', 'get', null);
                const hasAccess = response?.has_access === true;
                const subscriptionCode = response?.subscription_code || (hasAccess ? 'free' : fallbackCode);
                this.setState({
                    hasSubscriptionAccess: hasAccess,
                    subscriptionCode: subscriptionCode || "none",
                });
            } catch (error) {
                // Fallback to cached value if API fails
                this.setState({
                    hasSubscriptionAccess: null,
                    subscriptionCode: fallbackCode || "none",
                });
            }
        }

        render() {
            return <WrappedComponent
                {...this.props}
                subscriptionCode={this.state.subscriptionCode}
                hasSubscriptionAccess={this.state.hasSubscriptionAccess}
            />;
        }
    }

    const mapStateToProps = (state) => ({
        isLoggedin: state.loginReducer.isLoggedin,
    });

    return connect(mapStateToProps)(SubscriptionPermissionsControl);
};

export default SubscriptionPermissionsControl;
